import type { MapboxDirections } from '@/types/general';

interface MapboxTrip {
  distance: number;
  duration: number;
}

export const useMapboxHelper = () => {
  // CONFIG
  const runtimeConfig = useRuntimeConfig();
  const {
    public: { mapboxToken },
  } = runtimeConfig;
  const TRAVEL_TYPE = 'driving';
  const THG_HQ: [number, number] = [9.059191455261331, 47.06968479879075]; // THG headquarters
  const BB_EU = '-10.761452,35.753478,47.008095,71.240712'; // roughly the bounding box of europe

  // FUNCTIONS
  interface DirectionsParams {
    type?: string;
    from: [number, number];
    to?: [number, number];
  }
  async function calculateTrip({
    type = TRAVEL_TYPE,
    from,
    to = THG_HQ,
  }: DirectionsParams): Promise<MapboxTrip | null> {
    const url = getDirectionsUrl(type, from, to);
    try {
      const response = await $fetch<MapboxDirections>(url);
      return {
        distance: Math.round(response.routes[0].distance / 1000),
        duration: Math.round(response.routes[0].duration / 60),
      };
    } catch {
      console.error('Error fetching directions');
      return null;
    }
  }

  function getDirectionsUrl(type: string, start: [number, number], end: [number, number]) {
    return `https://api.mapbox.com/directions/v5/mapbox/${type}/${start[0]},${start[1]};${end[0]},${end[1]}?steps=false&geometries=geojson&access_token=${mapboxToken}`;
  }
  function getPlacesUrl(address: string, locale: string) {
    return `https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${mapboxToken}&bbox=${BB_EU}&language=${locale}`;
  }

  return {
    calculateTrip,
    getPlacesUrl,
  };
};
